import { render } from "./horizontal_dots.svg.vue?vue&type=template&id=2fb7fe56"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__